// extracted by extract-css-chunks-webpack-plugin
module.exports = {"SpinnerContainer":"SpinnerContainer_2X7H2_v13-0-0","Spinner":"Spinner_3cSdq_v13-0-0","Spinner__ColorGrayDark50":"Spinner__ColorGrayDark50_3M7NK_v13-0-0"};
    if(module.hot) {
      // 1588357787932
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  